import { useMemo } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { associationEventType } from '../../../../constants';

import classes from './AssociationTogglerButtons.module.scss';

interface IAssociationTogglerButtons {
  buttonClickHandler: (e: string) => void
}

const AssociationTogglerButtons = ({ buttonClickHandler }: IAssociationTogglerButtons) => {
  const { t: translate } = useTranslation();
  const { pathname } = useLocation();
  const defaultTogglerValue = useMemo(() => (pathname.includes(associationEventType.EGRESS) ? 2 : 1), [pathname]);
  return (
    <div className={classes['association-toggle-buttons']}>
      <ToggleButtonGroup
        type="radio"
        name="options"
        defaultValue={defaultTogglerValue}
        className={classes['toggle-btn-grp']}
      >
        <ToggleButton
          id="tbg-radio-1"
          value={1}
          className={`${classes['view-btn']} ${classes['ingress-view-btn']} `}
          data-testid="ingress-toggle-btn"
          onClick={() => buttonClickHandler(associationEventType.INGRESS)}
        >
          {`${translate('event_associations.lbl_toggle_ingress')}`}
        </ToggleButton>
        <ToggleButton
          id="tbg-radio-2"
          value={2}
          className={`${classes['view-btn']} ${classes['egress-view-btn']}`}
          data-testid="egress-toggle-btn"
          onClick={() => buttonClickHandler(associationEventType.EGRESS)}
        >
          {`${translate('event_associations.lbl_toggle_egress')}`}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default AssociationTogglerButtons;
